/**
 * Returns the current date and time.
 * This is a simple helper function to improve readability
 * when getting the current date throughout the application.
 *
 * @returns The current Date object
 */
export const now = (): Date => {
  return new Date();
};
